import { Pipe, PipeTransform } from '@angular/core';
import { defaultContentTypes } from '../config/constants';

/**
 * Transforms a content type DB value (e.g. 'pharmacovigilance')
 * into its human-readable label (e.g. 'Safety/MedInfo/Ops').
 * Falls back to TitleCase of the raw value if no match is found.
 */
@Pipe({
  name: 'contentTypeLabel',
  standalone: true,
  pure: true,
})
export class ContentTypeLabelPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const match = defaultContentTypes.find(
      (ct) => ct.value.toLowerCase() === value.toLowerCase(),
    );
    if (match) return match.name;
    // Fallback: capitalise first letter of each word
    return value
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }
}
